module.exports = __webpack_public_path__ + "img/installing_mounting_wedge_wired.0bda6b42.png";